import { render, staticRenderFns } from "./CapitulosEspeciales.vue?vue&type=template&id=fc014472"
import script from "./CapitulosEspeciales.vue?vue&type=script&lang=js"
export * from "./CapitulosEspeciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc014472')) {
      api.createRecord('fc014472', component.options)
    } else {
      api.reload('fc014472', component.options)
    }
    module.hot.accept("./CapitulosEspeciales.vue?vue&type=template&id=fc014472", function () {
      api.rerender('fc014472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/CapitulosEspeciales.vue"
export default component.exports